export default [
  {
    path: 'relatorios/gecom-home/gefin-mobile',
    name: 'gefin-mobile',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Gefin',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Relatórios', link: 'relatorios' },
        { name: 'Gefin' },
      ]
    }
  },
]